import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/iview.js'
import './style/theme-custom.less'
import './style/app.less'
import { locale } from 'view-design'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'view-design/dist/locale/en-US'
locale(lang)

Vue.use(ElementUI)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.query.JSESSIONID) {
    localStorage.setItem('TOKEN', to.query.JSESSIONID)
    next({ path: to.path })
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
